import React from 'react'

function CCD_program_details() {
  return (
    <div>
    {/* ------------------Mobile view-------------------- */}
    <div className='d-sm-block d-md-none'>
      <div className='container'>
        <div className='row'>
            <div className='col-md-12 detail_1stcomp_img'>
                <div className='Mobile_view_Program_details_1stcomp_text text-center'>
                    <h1 className='display-6'>Master In C/C++ With DSA</h1>
                    <p className='py-2'>Unlock the secrets of C/C++ with Data Structures and Algorithms. Enroll now in this advanced program for a brighter future in the world of coding excellence!</p>
                </div>
                <div className='mt-4 Mobile_view_Program_details_1stcomp_text text-center'>
                    <h1 className='display-4'>Overview</h1>
                    <p className='py-2'>Take a thorough look at Data Structures & Algorithms and C/C++ programming. This course gives you the tools to take on challenges in the real world. You will learn about advanced topics like OOPs, Trees, and Dynamic Programming, as well as fundamental concepts like functions, arrays, and conditional statements. Establish a strong foundation in problem-solving, coding, and algorithmic thinking, which will lead to the creation of small and large projects. Boost your programming skills with an organized course that is meant to succeed.</p>
                </div>
            </div>
            <div className='col-md-12'>
                <div>
                <div className=' Details_container shadow-lg px-3 py-4'>
                <h1 className='mobile_view_Details_text text-center  pb-2 border-bottom'>DSA with C, C++</h1>
                  <div className='mobile_view_Details_text'>
                    <ul className='pt-2'>
                      <li>Live conversations with industry professionals</li>
                      <li className='py-3'>Project support and Guidance</li>
                      <li>Access to Specialized Course Materials</li>
                      <li className='py-3'>25+ Hours of Learning</li>
                      <li>Certificates from reputable MNC's around the world</li>
                    </ul>
                  </div>
                  <div className='text-center'>
                  {/* <a href=''><button className="text-white shadow-sm mt-3 fs-5 px-5 pt-1 pb-2 Pr_details_button">Enroll Now</button></a> */}
                  </div>
                </div>
                </div>
            </div>
        </div>
      </div>
    </div>

    {/* ----------------------Desktop View----------------------- */}
    <div className='d-none d-md-block'>
      <div className='container'>
        <div className='row'>
            <div className='col-md-8 detail_1stcomp_img'>
                <div className='pt-3 Program_details_1stcomp_text'>
                    <h1 className='display-6'>Master In C/C++ With DSA</h1>
                    <p className='py-4'>Unlock the secrets of C/C++ with Data Structures and Algorithms. Enroll now in this advanced program for a brighter future in the world of coding excellence!</p>
                </div>
                <div className='mt-3 Program_details_1stcomp_text'>
                    <h1 className='display-3'>Overview</h1>
                    <p className='py-4'>Take a thorough look at Data Structures & Algorithms and C/C++ programming. This course gives you the tools to take on challenges in the real world. You will learn about advanced topics like OOPs, Trees, and Dynamic Programming, as well as fundamental concepts like functions, arrays, and conditional statements. Establish a strong foundation in problem-solving, coding, and algorithmic thinking, which will lead to the creation of small and large projects. Boost your programming skills with an organized course that is meant to succeed.</p>
                </div>
            </div>
            <div className='col-md-4'>
                <div>
                <div className=' Details_container shadow-lg px-3 pt-4 pb-5'>
                <h1 className='Details_text text-center  pb-4 pt-3 border-bottom'>DSA with C, C++</h1>
                  <div className='Details_text '>
                    <ul className='pt-4'>
                      <li>Live conversations with industry professionals</li>
                      <li className='py-3'>Project support and Guidance</li>
                      <li>Access to Specialized Course Materials</li>
                      <li className='py-3'>25+ Hours of Learning</li>
                      <li>Certificates from reputable MNC's around the world</li>
                    </ul>
                  </div>
                  <div className='text-center'>
                  {/* <a href=''><button className="text-white shadow-sm mt-3 fs-5 px-5 pt-1 pb-2 Pr_details_button">Enroll Now</button></a> */}
                  </div>
                </div>
                </div>
            </div>
        </div>
      </div>
    </div>
    </div>
  )
}

export default CCD_program_details
